const getValidClientName = (value) => {
  if (typeof value !== 'string') {
    return ''
  }

  return value.trim() === '' ? '' : value
}

export const getReportClientName = (report) => {
  return (
    getValidClientName(report?.cliente?.nome) ||
    getValidClientName(report?.input_options?.client)
  )
}
